"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const components_1 = require("../../../components");
const ModalUnFollow_1 = __importDefault(require("../../../components/modal/ModalUnFollow"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const Basic_1 = __importDefault(require("../../../networking/apis/Basic"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const components_2 = require("../components");
const styles_1 = __importDefault(require("./styles"));
const Followers = (props) => {
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { userHandle } = props?.route?.params;
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const [selectedUser, setSelectedUser] = (0, react_1.useState)();
    const [follow, setFollow] = (0, react_1.useState)([]);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isEmpty, setIsEmpty] = (0, react_1.useState)(false);
    const refCurrentPage = (0, react_1.useRef)(1);
    const refIsNoMore = (0, react_1.useRef)(false);
    const refIsCallingAPI = (0, react_1.useRef)(false);
    const isAnonymous = myProfile?.registration_status == 0;
    const modalVisible = !!selectedUser;
    (0, react_1.useEffect)(() => {
        loadFollowUser();
    }, []);
    const loadFollowUser = () => {
        if (refIsNoMore.current || isLoading)
            return;
        setLoading(true);
        Basic_1.default.getFollowerUser(refCurrentPage.current, userHandle)
            .then(response => {
            // update total on first time call
            if (refCurrentPage.current == 1) {
                new react_native_1.NativeEventEmitter().emit(constants_1.listenerEvents.FOLLOWER_COUNTER_UPDATE, response.data.total);
            }
            refCurrentPage.current = refCurrentPage.current + 1;
            if (refCurrentPage.current > response.data.last_page) {
                refIsNoMore.current = true;
            }
            if (response.data.total == 0) {
                setIsEmpty(true);
            }
            if (response?.data?.data?.length > 0) {
                setFollow([...follow, ...response.data.data]);
            }
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    const handleUnfollowUser = () => {
        const id = selectedUser?.user_id;
        if (refIsCallingAPI.current || !id)
            return;
        refIsCallingAPI.current = true;
        setSelectedUser(undefined);
        Basic_1.default.unfollowUser(id)
            .then(() => {
            setFollow((prev) => prev.map((follower) => {
                if (follower.user_id === id) {
                    return { ...follower, is_followed: 0 };
                }
                return follower;
            }));
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handleFollowUser = (hashtagId) => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingAPI.current)
            return;
        refIsCallingAPI.current = true;
        Basic_1.default.followUser(hashtagId)
            .then(() => {
            setFollow((prev) => prev.map((follower) => {
                if (follower.user_id === hashtagId) {
                    return { ...follower, is_followed: 1 };
                }
                return follower;
            }));
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handlePress = (event, user, position) => {
        if (user.is_followed == 0) {
            handleFollowUser(user.user_id);
        }
        else {
            const { pageY } = event.nativeEvent;
            setModalPosition({ x: position.right, y: position.bottom });
            setSelectedUser(user);
        }
    };
    const renderItem = ({ item }) => (react_1.default.createElement(components_2.FollowUser, { item: item, onPress: handlePress, handleFollowUser: handleFollowUser }));
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(react_native_1.FlatList, { data: follow, renderItem: renderItem, keyExtractor: (item) => `${item.user_id}`, contentContainerStyle: {
                paddingTop: (0, scale_1.scale)(12),
                paddingBottom: inset.bottom + (0, scale_1.scale)(100)
            }, onScroll: ({ nativeEvent }) => {
                if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                    loadFollowUser();
                }
            }, scrollEventThrottle: 400, ListFooterComponent: isLoading ? (react_1.default.createElement(components_1.LoadingView, { style: styles_1.default.loading }))
                : null, ListEmptyComponent: () => (isEmpty && react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.emptyText }, "\u30D5\u30A9\u30ED\u30EF\u30FC\u306F\u3044\u307E\u305B\u3093")) }),
        react_1.default.createElement(ModalUnFollow_1.default, { visible: modalVisible, onClose: () => setSelectedUser(undefined), modalPosition: modalPosition, hashTag: selectedUser?.nickname, openModalNoti: handleUnfollowUser })));
};
exports.default = Followers;
